const getters = {
  WJCS_wellName: state => state.WJCSwell.wellName,
  WJCS_wellNum: state => state.WJCSwell.wellNum,
}

export default getters